import React from "react";
import PropsTypes from "prop-types";
import { BiX } from "react-icons/bi";

function CustomModal({
  title: sTitle,
  children: oChildren,
  show: bShow = false,
  className: sClassName = "",
  onClose: onClose = () => { },
}) {
  return (
    bShow && <>
      <div className="fixed top-0 right-0 h-screen w-screen z-40 bg-gray-900 opacity-40" />
      <div className="fixed z-50 top-0 right-0 h-screen w-screen flex items-center justify-center p-4" onClick={onClose} >
        <div className={"rounded-lg border border-line dark:border-line-dark shadow-xl max-w-xs md:max-w-md max-h-[90vh] overflow-auto " + sClassName} onClick={oEvent => oEvent.stopPropagation()} >
          <div className="flex items-center justify-between gap-3 px-4 py-3 bg-white dark:bg-gray-800 border-b border-line dark:border-line-dark">
            <span className="text-sm font-medium text-gray-800 dark:text-white">{sTitle}</span>
            <BiX size={20} className="cursor-pointer text-gray-400 hover:text-gray-600 dark:hover:text-gray-200" onClick={onClose} />
          </div>
          <div className="bg-white text-gray-700 dark:bg-gray-800 dark:text-gray-300 p-4">
            {oChildren}
          </div>
        </div>
      </div>
    </>
  );
}

CustomModal.propTypes = {
  title: PropsTypes.string,
  show: PropsTypes.bool.isRequired,
  onClose: PropsTypes.func.isRequired,
};

export default CustomModal;
